import script from "./EditLocation.vue?vue&type=script&setup=true&lang=js"
export * from "./EditLocation.vue?vue&type=script&setup=true&lang=js"

import "./EditLocation.vue?vue&type=style&index=0&id=a37a973e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a37a973e"]])

export default __exports__